class ProjectHeaderComponent extends HTMLElement {
  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="row" style="max-width: 900px;">
        <div class="col-12" style="margin-top: 10px;">
          <div id="top-design-summary-panel" class="card card-success" >
            <div class="card-header">
              <div class="row">
                <h4>
                  <span class="float-start">
                    <a href="#" id="project-title" style="text-decoration: none;" data-type="text"
                      data-title="Untitled Beam" onclick="openProjectHeaderSettingsDialog();">
                      Untitled Beam
                    </a>
                    <a id="active-project-title-needs-saved" class="text-muted text-danger hidden-print"
                      style="cursor: pointer;" onClick="saveActiveProject();">
                      <small><em><span id="saved-time-ago"></span></em></small>
                    </a>
                  </span>
                  <span class="float-end" >
                    <span class="current-design-status" style="cursor:pointer;" onclick="doBeamFlexureDesign()">Analyze
                      Now</span>
                  </span>
                </h4>
              </div>
              <div class="row float-start">
                <a href="#" id="your-company-name" style="text-decoration: none;" data-type="text"
                  data-title="Your Company Name" onclick="openProjectHeaderSettingsDialog();">
                  Your Company Name
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      `
  }
}

customElements.define('project-header', ProjectHeaderComponent);